import {Card, CardContent, CardHeader, Container} from '@mui/material';
import React from 'react';

import {Spinner} from './common/Loading';

export default function UIDemo(props) {
    return (
        <Container>
            <Card>
                <CardHeader>Spinner Demo</CardHeader>
                <CardContent>
                    <Spinner></Spinner>
                </CardContent>
            </Card>
        </Container>
    );
}
